import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GenericaService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // Pesquisa por Representante de Ensino e Gestora
  public pesquisa(params?: any): Observable<any> {
    return this.apiService
      .get<{ data: any[] }>(
        `${this.path}/PesquisaPorRepresentanteEnsinoEGestora`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params
      )
      .pipe(map((response) => response));
  }

  listPaisGenerico(params: any): Observable<any> {
    return this.apiService.get(`${this.path}/GetListarPaisPorBolsaInternaOuExterna`, params);
  }
}
